import Cookies from 'js-cookie';

export default () => {

  const alertBanner = $('.alert-banner'),
        alertBannerClose = $('.js-alert-banner-close'),
        cookieExpiration = alertBanner.data('cookie-expiration');

  if (alertBanner.length) {

    alertBannerClose.on('click', (e) => {
      e.preventDefault();
      alertBanner.slideUp(400);
      alertBanner.attr('aria-hidden', 'true');

      if (cookieExpiration > 0) {
        Cookies.set('asce_alert_banner', 'true', { expires: cookieExpiration });
      } else {
        Cookies.set('asce_alert_banner', 'true');
      }

    });

  }

};
